import { Board } from './Board';
import { Cups } from './Cups';
import { Ground } from './Ground';

export const Game: React.FC = () => (
  <>
    <Board />
    <Ground />
    <Cups />
  </>
);
